// Constantes para categorização de quantidade de palavras
const TEN = 10
const FIFTEEN = 15
const TWENTY = 20
const TWENTY_FIVE = 25
const THIRTY = 30
const THIRTY_FIVE = 35
const FORTY = 40
const FORTY_FIVE = 45

// Fatores de fonte ajustados para card de 100x100px com padding de 8px
// Área útil: 84x84px (100 - 8*2)
const fontFactor = {
  [TEN]: 12,
  [FIFTEEN]: 11,
  [TWENTY]: 10,
  [TWENTY_FIVE]: 9,
  [THIRTY]: 8,
  [THIRTY_FIVE]: 8,
  [FORTY]: 7,
  [FORTY_FIVE]: 7,
}

export const getFont = (words: string[]): number => {
  const maxWordLength = Math.max(...words.map((w) => w.length), 0)

  let baseFont: number
  if (words.length <= TEN)
    baseFont = fontFactor[TEN]
  else if (words.length > TEN && words.length <= FIFTEEN)
    baseFont = fontFactor[FIFTEEN]
  else if (words.length > FIFTEEN && words.length <= TWENTY)
    baseFont = fontFactor[TWENTY]
  else if (words.length > TWENTY && words.length <= TWENTY_FIVE)
    baseFont = fontFactor[TWENTY_FIVE]
  else if (words.length > TWENTY_FIVE && words.length <= THIRTY)
    baseFont = fontFactor[THIRTY]
  else if (words.length > THIRTY && words.length <= THIRTY_FIVE)
    baseFont = fontFactor[THIRTY_FIVE]
  else if (words.length > THIRTY_FIVE && words.length <= FORTY)
    baseFont = fontFactor[FORTY]
  else baseFont = fontFactor[FORTY_FIVE]

  // Ajuste fino baseado no comprimento da maior palavra
  // Valores ajustados para não extrapolar o card de 100x100px
  if (maxWordLength > 18) return Math.max(baseFont - 3, 4) // Mínimo 4px
  if (maxWordLength > 15) return Math.max(baseFont - 3, 4) // Mínimo 4px
  if (maxWordLength > 12) return Math.max(baseFont - 2, 4) // Mínimo 4px
  if (maxWordLength < 8 && words.length < 15) return Math.min(baseFont + 1, 14) // Máximo 14px

  return baseFont
}
